//
// Skinned Box
//
// Creates a box on screen that uses a texture for skinning.
// The four corners are taken directly from the four corners of the texture, everything else is scaled.
// The corner is defined by "cornerWidth, cornerHeight" (each corner is the same size)
//
//   For example, if the textture is 100 width and 100 height, and the corners are set to 25,25:
//   ------------
//   25|  50  |25
//   ------------
//   50|      |25
//   ------------
//   25|  50  |25
//   ------------

skinnedBox = {};
skinnedBox.boxLocations = [ [0,0], [1,0], [0, 1], [1,1] ];

skinnedBox.getRequiredFiles = function(json) {
    return [ ReflexLoader.rootResDir + json.textureName ];
};

skinnedBox.createSkinnedBox = function(json) {


    skinnedBox.container = new PIXI.Container();


    return skinnedBox.container;
};

skinnedBox.initialiseSkinnedBox = function(json) {
    var edgeTexture;
    var edgeSprite;
    var cornerTexture;
    var cornerSprite;
    var x;
    var y;

    //skinnedBox.container.Props = {};
    skinnedBox.container.components = {};
    skinnedBox.container.anchor = json.anchor;

    skinnedBox.container.anchoredContainer = new PIXI.Container();
    skinnedBox.container.addChild(skinnedBox.container.anchoredContainer);

    var textureName = ReflexLoader.rootResDir + json.textureName;

    if (PIXI.utils.TextureCache[textureName] === undefined) {
        console.error("Texture \"" + textureName + "\" for object \"" + json.FQN + "\" was not found in cache");
        return;
    }

    skinnedBox.container.textureWidth = PIXI.utils.TextureCache[textureName].width;
    skinnedBox.container.textureHeight = PIXI.utils.TextureCache[textureName].height;

    var boxWidth = json.width * resourceManager.selectedAssetResolution.scale;
    var boxHeight = json.height * resourceManager.selectedAssetResolution.scale;

    skinnedBox.container.leftCornerWidth;
    skinnedBox.container.rightCornerWidth;
    skinnedBox.container.topCornerHeight;
    skinnedBox.container.bottomCornerHeight;

    if(typeof(json.cornerWidth) !== "undefined" && typeof(json.cornerHeight) !== "undefined"){
        skinnedBox.container.leftCornerWidth = json.cornerWidth * resourceManager.selectedAssetResolution.scale;
        skinnedBox.container.rightCornerWidth = json.cornerWidth * resourceManager.selectedAssetResolution.scale;
        skinnedBox.container.topCornerHeight = json.cornerHeight * resourceManager.selectedAssetResolution.scale;
        skinnedBox.container.bottomCornerHeight = json.cornerHeight * resourceManager.selectedAssetResolution.scale;
    }
    else if(typeof(json.leftCornerWidth) !== "undefined" && typeof(json.rightCornerWidth) !== "undefined" &&
        typeof(json.topCornerHeight) !== "undefined" && typeof(json.bottomCornerHeight) !== "undefined"){
        skinnedBox.container.leftCornerWidth = json.leftCornerWidth * resourceManager.selectedAssetResolution.scale;
        skinnedBox.container.rightCornerWidth = json.rightCornerWidth * resourceManager.selectedAssetResolution.scale;
        skinnedBox.container.topCornerHeight = json.topCornerHeight * resourceManager.selectedAssetResolution.scale;
        skinnedBox.container.bottomCornerHeight = json.bottomCornerHeight * resourceManager.selectedAssetResolution.scale;
    }

    skinnedBox.container.dimensions = [
        {cornerWidth:skinnedBox.container.leftCornerWidth, cornerHeight:skinnedBox.container.topCornerHeight},
        {cornerWidth:skinnedBox.container.rightCornerWidth, cornerHeight:skinnedBox.container.topCornerHeight},
        {cornerWidth:skinnedBox.container.rightCornerWidth, cornerHeight:skinnedBox.container.bottomCornerHeight},
        {cornerWidth:skinnedBox.container.leftCornerWidth, cornerHeight:skinnedBox.container.bottomCornerHeight}
    ];

    skinnedBox.container.components.corners = [];
    for (var i = 0; i < 4; i++) {
        // Create the texture we need for this corner
        cornerTexture = new PIXI.Texture(PIXI.utils.TextureCache[textureName]);
        x = PIXI.utils.TextureCache[textureName].frame.x + skinnedBox.container.textureWidth * skinnedBox.boxLocations[i][0] - skinnedBox.container.dimensions[i].cornerWidth * skinnedBox.boxLocations[i][0];
        y = PIXI.utils.TextureCache[textureName].frame.y + skinnedBox.container.textureHeight * skinnedBox.boxLocations[i][1] - skinnedBox.container.dimensions[i].cornerHeight * skinnedBox.boxLocations[i][1];
        cornerTexture.frame = new PIXI.Rectangle(x, y, skinnedBox.container.dimensions[i].cornerWidth, skinnedBox.container.dimensions[i].cornerHeight);

        cornerSprite = new PIXI.Sprite(cornerTexture);
        skinnedBox.container.anchoredContainer.addChild(cornerSprite);
        skinnedBox.container.components.corners.push(cornerSprite);
    }

    var innerTextureWidth = skinnedBox.container.textureWidth - (skinnedBox.container.leftCornerWidth + skinnedBox.container.rightCornerWidth);
    var innerTextureHeight = skinnedBox.container.textureHeight - (skinnedBox.container.topCornerHeight + skinnedBox.container.bottomCornerHeight);

    // Add the edges (top, left, right, bottom)
    edgeTexture = new PIXI.Texture(PIXI.utils.TextureCache[textureName]);
    edgeTexture.frame = new PIXI.Rectangle(PIXI.utils.TextureCache[textureName].frame.x + skinnedBox.container.leftCornerWidth, PIXI.utils.TextureCache[textureName].frame.y , innerTextureWidth, skinnedBox.container.topCornerHeight);
    skinnedBox.container.components.top = new PIXI.Sprite( edgeTexture );
    skinnedBox.container.anchoredContainer.addChild( skinnedBox.container.components.top );

    edgeTexture = new PIXI.Texture(PIXI.utils.TextureCache[textureName]);
    edgeTexture.frame = new PIXI.Rectangle(PIXI.utils.TextureCache[textureName].frame.x , PIXI.utils.TextureCache[textureName].frame.y + skinnedBox.container.topCornerHeight, skinnedBox.container.leftCornerWidth, innerTextureHeight);
    skinnedBox.container.components.left = new PIXI.Sprite( edgeTexture );
    skinnedBox.container.anchoredContainer.addChild( skinnedBox.container.components.left );

    edgeTexture = new PIXI.Texture(PIXI.utils.TextureCache[textureName]);
    edgeTexture.frame = new PIXI.Rectangle(PIXI.utils.TextureCache[textureName].frame.x + (skinnedBox.container.textureWidth - skinnedBox.container.rightCornerWidth), PIXI.utils.TextureCache[textureName].frame.y + skinnedBox.container.topCornerHeight, skinnedBox.container.rightCornerWidth, innerTextureHeight);
    skinnedBox.container.components.right = new PIXI.Sprite( edgeTexture );
    skinnedBox.container.anchoredContainer.addChild( skinnedBox.container.components.right );

    edgeTexture = new PIXI.Texture(PIXI.utils.TextureCache[textureName]);
    edgeTexture.frame = new PIXI.Rectangle(PIXI.utils.TextureCache[textureName].frame.x + skinnedBox.container.leftCornerWidth, PIXI.utils.TextureCache[textureName].frame.y + (skinnedBox.container.textureHeight - skinnedBox.container.bottomCornerHeight), innerTextureWidth, skinnedBox.container.bottomCornerHeight);
    skinnedBox.container.components.bottom = new PIXI.Sprite( edgeTexture );
    skinnedBox.container.anchoredContainer.addChild( skinnedBox.container.components.bottom );

    var centerTexture = new PIXI.Texture(PIXI.utils.TextureCache[textureName]);
    centerTexture.frame = new PIXI.Rectangle(PIXI.utils.TextureCache[textureName].frame.x + skinnedBox.container.leftCornerWidth, PIXI.utils.TextureCache[textureName].frame.y + skinnedBox.container.topCornerHeight, innerTextureWidth, innerTextureHeight);
    skinnedBox.container.components.center = new PIXI.Sprite( centerTexture );
    skinnedBox.container.anchoredContainer.addChild( skinnedBox.container.components.center );

    skinnedBox.container.setSize = function(width, height) {
        var boxWidth = width * resourceManager.selectedAssetResolution.scale;
        var boxHeight = height * resourceManager.selectedAssetResolution.scale;
        var boxInnerWidth = boxWidth - (this.leftCornerWidth + this.rightCornerWidth);
        var boxInnerHeight = boxHeight - (this.topCornerHeight + this.bottomCornerHeight);

        for (var i = 0; i < 4; i++) {
            // Create the texture we need for this corner
            this.components.corners[i].position.x = boxWidth * skinnedBox.boxLocations[i][0] - this.dimensions[i].cornerWidth * skinnedBox.boxLocations[i][0];
            this.components.corners[i].position.y = boxHeight * skinnedBox.boxLocations[i][1] - this.dimensions[i].cornerHeight * skinnedBox.boxLocations[i][1];
        }

        this.components.top.position.set(this.leftCornerWidth, 0);
        this.components.top.width = boxInnerWidth;

        this.components.left.position.set(0, this.topCornerHeight);
        this.components.left.height = boxInnerHeight;

        this.components.right.position.set(boxWidth - this.rightCornerWidth, this.topCornerHeight);
        this.components.right.height = boxInnerHeight;

        this.components.bottom.position.set(this.leftCornerWidth, boxHeight - this.bottomCornerHeight);
        this.components.bottom.width = boxInnerWidth;

        this.components.center.width = boxInnerWidth;
        this.components.center.height = boxInnerHeight;
        this.components.center.position.set(this.leftCornerWidth, this.topCornerHeight);


        if (checkForDefined(this.anchor)) {
            if (typeof(this.anchor) === "object") {
                this.anchoredContainer.position.x = -boxWidth * this.anchor.x;
                this.anchoredContainer.position.y = -boxHeight * this.anchor.y;
            }
            else {
                this.anchoredContainer.position.x = -boxWidth * this.anchor;
                this.anchoredContainer.position.y = -boxHeight * this.anchor;
            }
        }

    };

    skinnedBox.container.setSize(json.width, json.height);

};




resourceManager.registerObjectType("skinnedBox", skinnedBox.createSkinnedBox, skinnedBox.initialiseSkinnedBox, skinnedBox.getRequiredFiles);
